import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import saApi from "../lib/saApi";

const SuperAdminAuthCtx = createContext(null);

export function SuperAdminAuthProvider({ children }) {
  const [sa, setSa] = useState(null);
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await saApi.get("/auth/me");
      setSa(data.user);
      setFeatures(data.features_catalog || []);
    } catch {
      setSa(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await saApi.post("/auth/login", { email, password });
    setSa(data.user);
    setFeatures(data.features_catalog || []);
    return data.user;
  };

  const logout = async () => {
    try { await saApi.post("/auth/logout"); } catch { /* ignore */ }
    setSa(null);
    window.location.href = "/superadmin/login";
  };

  const has = (feature) => {
    if (!sa) return false;
    if (sa.is_master) return true;
    const allowed = sa.allowed_features || [];
    return allowed.includes(feature);
  };

  return (
    <SuperAdminAuthCtx.Provider value={{ sa, features, loading, login, logout, refresh, has }}>
      {children}
    </SuperAdminAuthCtx.Provider>
  );
}

export const useSuperAdminAuth = () => useContext(SuperAdminAuthCtx);
